import { useGLTF, useTexture } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { PlaneGeometry, MeshBasicMaterial, MeshPhysicalMaterial } from 'three'
import {Environment} from '@react-three/drei'
import HDR from '../assets/textures/environment.hdr'
import { useRef } from 'react'
import * as THREE from 'three'

import ThreeLogoPanel from './three/logoPanel.three'
import ThreeTextPanel from './three/textPanel.three'
import ThreeBackPanel from './three/backPanel.three'
import ThreePatternPanel from './three/patternPanel.three'


import CARD_MESH from '../assets/mesh.glb'
import {METAL_TEXTURE, B1_LOGO_WHITE} from '../utils/static.utils'

export default function Scene({state, methods, ...props}){
    const {cardType, cardMaterial, cardColor, cardText, selectedPattern, cardLogoUrl} = state
    const groupRef = useRef()
    const {nodes, materials} = useGLTF(CARD_MESH)
    
    
    const metalTexture = useTexture(METAL_TEXTURE) 
    
    
    const metalMaterial= new MeshPhysicalMaterial({
        roughness: cardMaterial.roughness,
        metalness: cardMaterial.metalness,
        bumpMap: metalTexture,
        bumpScale: 0.005,
        roughnessMap: cardMaterial.metalness == 1 ? metalTexture : null,
        metalnessMap: cardMaterial.metalness == 1 ? metalTexture : null,
        color: cardColor.name === "Nero" ? "#000000" : cardColor.hex,
        side: THREE.DoubleSide,
        
    })
    
    const pvcMaterial = new THREE.MeshStandardMaterial({
        color: cardColor.hex,
        reflectivity: 0,
        roughness: 1,
        map:metalTexture,
        bumpMap: metalTexture,
        bumpScale: 0.005,
        flatShading: true,
        roughnessMap: metalTexture ,
        
    })
    
    const { geometry }= nodes.card_model
    
    useFrame((state) => {
        const t = state.clock.getElapsedTime()
        
        groupRef.current.rotation.z = -0.2 - (1 + Math.sin(t / 1.5)) / 20
        groupRef.current.rotation.x = (Math.cos(t/4) / 8) + Math.PI / 2
        groupRef.current.rotation.y = Math.sin(t/4) / 8
        groupRef.current.position.y = (1 + Math.sin(t / 1.5)) / 10
        
        //groupRef.current.rotation.x = Math.PI / 2
    })
    
    
    const material = cardMaterial.type === "m" ? metalMaterial : pvcMaterial
    
    return (
        <group dispose={null} ref={groupRef}>
            <mesh receiveShadows castShadows geometry={geometry} material={material} />
            <ThreePatternPanel cardType={cardType} cardPattern={selectedPattern} geometry={nodes.front_panel.geometry} cardColor={cardColor} rotation={groupRef.rotation} position={groupRef.position}/>
            <ThreeBackPanel cardType={cardType} cardColor={cardColor} geometry={nodes.back_panel.geometry} rotation={groupRef.rotation} position={groupRef.position} />
            {cardType.hasLogo && !cardType.customLogo && <ThreeLogoPanel cardColor={cardColor} cardMaterial={cardMaterial} rotation={groupRef.rotation} position={groupRef.position} texture={B1_LOGO_WHITE}/> }
            {cardType.hasLogo && cardType.customLogo && cardLogoUrl != null && <ThreeLogoPanel cardColor={cardColor} cardMaterial={cardMaterial} material={material} isCustomLogo={true} rotation={groupRef.rotation} cardText={cardText} position={groupRef.position} texture={cardLogoUrl}/> }
            {cardType.customText && <ThreeTextPanel cardState={state} rotation={groupRef.rotation} cardColor={cardColor} position={groupRef.position} text={cardText} />}
              <Environment   files={HDR} /> 
        </group>
    )
}
